"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class WiperHepaSearchController {
    constructor(sectionsId) {
        this.searchWiperCollection = (wiperSearchOption) => __awaiter(this, void 0, void 0, function* () {
            const res = yield moobiTypeSenseClient.collections('hepaKWiperSearchData').documents().search(wiperSearchOption);
            return res;
        });
        this.initState = {
            brand: {
                brand: undefined,
                brandQuery: undefined,
            },
            model: {
                modelQuery: undefined,
                timer: this.createRefactoryTracker(1500)
            },
            query: {
                page: 1,
                per_page: 10
            },
            result: {
                documents: [],
            },
            sectionsId: {
                brandSelect: sectionsId.brandSelect,
                queryTextField: sectionsId.queryTextField,
                resultsArea: sectionsId.resultsArea,
                queriesVP: sectionsId.queriesVP,
                resultCount: sectionsId.resultCount
            }
        };
        this.currentState = JSON.parse(JSON.stringify(this.initState));
        this.init();
    }
    // init
    init() {
        this.listenToModelQuery();
        this.hydrateBrandItems();
    }
    // Hydrate
    listenToModelQuery() {
        const textField = document.getElementById(this.initState.sectionsId.queryTextField);
        textField === null || textField === void 0 ? void 0 : textField.addEventListener('input', (evt) => {
            const target = evt.target;
            this.changeQueryHandler(target.value);
        });
        setInterval(() => { this.changeQueryHandler(textField.value); }, 1500);
    }
    hydrateBrandItems() {
        const brandContainer = document.getElementById(this.initState.sectionsId.brandSelect);
        if (!brandContainer)
            return;
        const brandItems = Array.from(brandContainer.querySelectorAll('.wiperBrandSelector_item'));
        brandItems.forEach((item) => {
            item.addEventListener('click', (evt) => __awaiter(this, void 0, void 0, function* () {
                const target = evt.target;
                const targetItem = MoobiUtilities.findNearestParentByClass(target, 'wiperBrandSelector_item');
                const brandTitle = targetItem.dataset.brandtitle;
                this.updateBrandSelected(brandTitle);
                yield this.evokeModelBrandQueryUpdate();
            }));
        });
    }
    hydratePaginationNumber(pagNum) {
        pagNum.addEventListener('click', (evt) => {
            const numbElm = evt.target;
            const pageNum = numbElm.dataset.pagenum;
            this.updatePageSelected(Number(pageNum));
            this.evokePageUpdate();
        });
    }
    hydratePaginationArrowR(arrowL, totalPages) {
        arrowL.addEventListener('click', (evt) => {
            const newPage = Number(this.currentState.query.page + 1) <= totalPages ? Number(this.currentState.query.page + 1) : totalPages;
            this.updatePageSelected(newPage);
            this.evokePageUpdate();
        });
    }
    hydratePaginationArrowL(arrowL) {
        arrowL.addEventListener('click', (evt) => {
            const newPage = Number(this.currentState.query.page - 1) > 0 ? Number(this.currentState.query.page - 1) : 1;
            this.updatePageSelected(newPage);
            this.evokePageUpdate();
        });
    }
    // Checks
    createRefactoryTracker(refactory) {
        let lastUpdateTime = 0;
        return function () {
            const timeNow = Date.now();
            if ((timeNow - lastUpdateTime) <= refactory) {
                return false;
            }
            lastUpdateTime = timeNow;
            return true;
        };
    }
    // Actions
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    // Handlers
    changeQueryHandler(newQuery) {
        return __awaiter(this, void 0, void 0, function* () {
            const prevQuery = this.currentState.model.modelQuery;
            if (newQuery === prevQuery)
                return;
            const ifPassedRefactoryTime = this.initState.model.timer;
            if (!ifPassedRefactoryTime())
                return;
            this.updateModelQuery(newQuery);
            this.evokeModelBrandQueryUpdate();
        });
    }
    changeBrandHandler(newBrand) {
        return __awaiter(this, void 0, void 0, function* () {
            const prevBrand = this.currentState.brand.brand;
            if (prevBrand === newBrand)
                return;
            this.updateModelQuery(newBrand);
            this.evokeModelBrandQueryUpdate();
        });
    }
    modelDivHandler(doc) {
        return __awaiter(this, void 0, void 0, function* () {
            const overlay = yield this.getResultExternalOverlay(doc);
            if (!overlay)
                return;
            MoobiUtilities.renderOverlayExternalCover({ externalSection: overlay });
        });
    }
    // update states
    updateBrandQuery(newBrand) {
        this.currentState.model.modelQuery = newBrand;
        return newBrand;
    }
    updateModelQuery(newQuery) {
        this.currentState.model.modelQuery = newQuery;
        return newQuery;
    }
    updateBrandSelected(newBrand) {
        if (this.currentState.brand.brand === newBrand)
            return;
        this.currentState.brand.brand = newBrand;
    }
    updatePageSelected(newPage) {
        if (this.currentState.query.page === newPage)
            return;
        this.currentState.query.page = newPage;
    }
    // Get Elm
    getModelDocuments(res) {
        const documents = res.hits.map((el) => { return el.document; });
        return documents;
    }
    getModelDiv(doc, handler) {
        const docDiv = document.createElement('div');
        docDiv.classList.add('wiperSearch_result_item');
        const title = document.createElement('h4');
        title.classList.add('h4main');
        title.innerText = doc.code;
        const brand = document.createElement('h4');
        brand.classList.add('brand', 'h5main');
        brand.innerText = doc.brand;
        const year = document.createElement('p');
        year.classList.add('sizes', 'paragraph03');
        year.innerText = `年份: ${doc.year}`;
        const leftNumber = document.createElement('p');
        leftNumber.classList.add('sizes');
        leftNumber.innerText = `乘客: ${doc.inch_side} 寸`;
        const rightNumber = document.createElement('p');
        rightNumber.classList.add('sizes');
        rightNumber.innerText = `司機: ${doc.inch_driver} 寸`;
        const adaptor = document.createElement('p');
        adaptor.classList.add('sizes');
        adaptor.innerText = doc.adaptor ? `接頭型號: No. ${doc.adaptor}` : '';
        const insertedDocDiv = this.bulkInsertElm(docDiv, [title, brand, year]);
        if (!doc.adaptor)
            adaptor.remove();
        insertedDocDiv.addEventListener('click', () => {
            const bound = handler.bind(this);
            bound(title);
        });
        return insertedDocDiv;
    }
    getWiperMainWrapper() {
        const resultWrapper = document.createElement('div');
        resultWrapper.classList.add('wiperSearch_resultOverlay');
        return resultWrapper;
    }
    getWiperImageWrapper(src) {
        const imageWrapper = document.createElement('div');
        imageWrapper.classList.add('wiperSearch_resultOverlay_imageWrapper');
        imageWrapper.classList.add('imageSkeleton');
        const image = document.createElement('img');
        image.src = src;
        imageWrapper.insertAdjacentElement('beforeend', image);
        return imageWrapper;
    }
    getWiperContentWrapper(doc, product, wiperInfo) {
        const contentWrapper = document.createElement('div');
        contentWrapper.classList.add('wiperSearch_resultOverlay_contentWrapper');
        const title = document.createElement('h2');
        title.innerText = product.title;
        title.classList.add('wiperSearch_resultOverlay_title');
        const adaptor = document.createElement('h3');
        if (doc.adaptor) {
            adaptor.innerText = `合適的接頭︰ ${doc.adaptor}`;
            adaptor.classList.add('wiperSearch_resultOverlay_adaptorTitle');
        }
        const modelTitle = document.createElement('h2');
        modelTitle.innerText = `${doc.brand}: ${doc.code}`;
        modelTitle.classList.add('wiperSearch_resultOverlay_modelTitle');
        const message = document.createElement('h4');
        message.innerText = '最合適閣下座駕的水撥尺寸為: ';
        const driverSize = document.createElement('p');
        driverSize.innerText = `駕駛座: ${doc.inch_driver}吋`;
        const sideSize = document.createElement('p');
        sideSize.innerText = doc.inch_side ? `副駛座: ${doc.inch_side}吋` : "副駛座:";
        const linkedButton = document.createElement('a');
        linkedButton.classList.add('wiperSearch_resultOverlay_linkedButton');
        linkedButton.href = '/cart';
        linkedButton.innerText = '前往購物車';
        const resultGrid = document.createElement('div');
        resultGrid.classList.add('wiperSearch_resultOverlay_Grid');
        if (wiperInfo) {
            const driverCartButton = this.getAddWiperButton(wiperInfo, { size: Number(doc.inch_driver), adaptor: doc.adaptor });
            const sideCartButton = this.getAddWiperButton(wiperInfo, { size: Number(doc.inch_side), adaptor: doc.adaptor });
            const gridElmsFiltered = [driverSize, driverCartButton, sideSize, sideCartButton].filter((el) => {
                if (el === undefined)
                    return false;
                else
                    return true;
            });
            this.bulkInsertElm(resultGrid, [...gridElmsFiltered]);
            const elmLists = [title, modelTitle, message, adaptor, resultGrid, linkedButton];
            this.bulkInsertElm(contentWrapper, [...elmLists]);
        }
        if (!wiperInfo) {
            this.bulkInsertElm(contentWrapper, [title, modelTitle, message, driverSize, sideSize, linkedButton]);
        }
        if (!doc.adaptor) {
            adaptor.remove();
        }
        return contentWrapper;
    }
    getUltimateElm(doc, productInfo) {
        const productTitle = productInfo ? productInfo.title : '3M 極致鍍膜水撥 Ultimate Coating Wiper Blades';
        const productImage = productInfo ? productInfo.image : 'https://moooooob.myshopify.com/cdn/shop/files/3M_HK_Ultimate_Coating_Wiper_blade_U_hook_for_Japanese_cars_Moobi_main_07f43ed5-6b09-48b7-9d2b-17ca1fea264d.jpg?v=1703828196';
        const productHandle = productInfo ? productInfo.handle : '3m-hk-ultimate-coating-wiper-blades';
        const resultWrapper = this.getWiperMainWrapper();
        const imageWrapper = this.getWiperImageWrapper(productImage);
        const contentWrapper = this.getWiperContentWrapper(doc, { title: productTitle, handle: productHandle }, productInfo);
        this.bulkInsertElm(resultWrapper, [imageWrapper, contentWrapper]);
        return resultWrapper;
    }
    getExtremeElm(doc, productInfo) {
        const productTitle = productInfo ? productInfo.title : '3M 至尊鍍膜水撥 Extreme Coating Wiper Blades';
        const productImage = productInfo ? productInfo.image : 'https://www.mymoobi.com/cdn/shop/files/3M_HK_Extreme_Coating_Wiper_blade_multifit_for_European_cars_Moobi_main_e061e446-3643-4754-815c-bc9a17f14daa.jpg?v=1703838997';
        const productHandle = productInfo ? productInfo.handle : '3m-hk-extreme-coating-wiper-blades-for-european-cars';
        const resultWrapper = this.getWiperMainWrapper();
        const imageWrapper = this.getWiperImageWrapper(productImage);
        const contentWrapper = this.getWiperContentWrapper(doc, { title: productTitle, handle: productHandle }, productInfo);
        this.bulkInsertElm(resultWrapper, [imageWrapper, contentWrapper]);
        return resultWrapper;
    }
    getUltimateResult(doc) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wiperInfo = yield this.getWiperInfo("3m-hk-ultimate-coating-wiper-blades");
                if (!wiperInfo)
                    throw new Error("No ultimate wiper info returned");
                return this.getUltimateElm(doc, wiperInfo);
            }
            catch (error) {
                console.log(error);
                return this.getUltimateElm(doc, undefined);
            }
        });
    }
    getExtremeResult(doc) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wiperInfo = yield this.getWiperInfo("3m-hk-extreme-coating-wiper-blades-for-european-cars");
                if (!wiperInfo)
                    throw new Error("No extreme wiper info returned");
                return this.getExtremeElm(doc, wiperInfo);
            }
            catch (error) {
                console.log(error);
                return this.getExtremeElm(doc, undefined);
            }
        });
    }
    getHepaResult(doc) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wiperInfo = yield this.getWiperInfo("hepa-king-silicone-coating-wiper-blades");
                if (!wiperInfo)
                    throw new Error("No extreme wiper info returned");
                return this.getExtremeElm(doc, wiperInfo);
            }
            catch (error) {
                console.log(error);
                return this.getExtremeElm(doc, undefined);
            }
        });
    }
    getResultExternalOverlay(doc) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(doc.product);
            if (doc.product === 'ultimate') {
                const resultDiv = yield this.getUltimateResult(doc);
                return resultDiv;
            }
            if (doc.product === 'extreme') {
                const resultDiv = this.getExtremeResult(doc);
                return resultDiv;
            }
            if (!doc.product) {
                const resultDiv = this.getHepaResult(doc);
                return resultDiv;
            }
        });
    }
    getSearchedBrands(res) {
        const searchedBrandCounts = res.facet_counts[0].counts;
        return searchedBrandCounts;
    }
    getCurrentQueriesDiv() {
        const modelQueryDiv = document.createElement('div');
        modelQueryDiv.classList.add('searchQueriesItem');
        modelQueryDiv.innerText = this.currentState.model.modelQuery ? this.currentState.model.modelQuery : "";
        return modelQueryDiv;
    }
    getCurrentBrandDiv() {
        const brandQueryDiv = document.createElement('div');
        brandQueryDiv.classList.add('searchBrandQueriesItem');
        brandQueryDiv.innerText = this.currentState.brand.brand ? this.currentState.brand.brand : "";
        brandQueryDiv.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
            this.updateBrandSelected('');
            yield this.evokeModelBrandQueryUpdate();
        }));
        return brandQueryDiv;
    }
    getPagination(res) {
        const target = document.getElementById('wiperResearchPagination_container');
        if (!target)
            return;
        target.innerHTML = '';
        const arrowL = document.createElement('p');
        arrowL.innerText = "<";
        const arrowR = document.createElement('p');
        arrowR.innerText = ">";
        const found = res.found;
        const perPageMax = this.initState.query.per_page;
        target.appendChild(arrowL);
        const totalPages = Math.ceil(found / perPageMax);
        this.hydratePaginationArrowL(arrowL);
        this.hydratePaginationArrowR(arrowR, totalPages);
        for (let i = 1; i <= totalPages; i++) {
            const pageElement = document.createElement('p');
            pageElement.innerText = i.toString();
            pageElement.dataset.pagenum = i.toString();
            this.hydratePaginationNumber(pageElement);
            target.appendChild(pageElement);
        }
        target.appendChild(arrowR);
        this.hideManyPagination(target);
    }
    getAddWiperButton(wiperInfo, options) {
        var _a;
        const matchingVariants = wiperInfo.variants.map((el) => {
            if (el.title.includes(JSON.stringify(options.size))) {
                return el;
            }
        }).filter((el) => { return !!el; });
        if (options.size === 0 || matchingVariants.length < 1 || !((_a = matchingVariants[0]) === null || _a === void 0 ? void 0 : _a.id)) {
            return this.getNoAddWiperInfo("不適用");
        }
        const adaptorJSON = options.adaptor ? JSON.stringify([{ key: "Wiper Adaptor", value: options.adaptor }]) : undefined;
        const buttonHtml = `<ajax-AddToCartButton data-variantid="${matchingVariants[0].id}" data-property='${adaptorJSON ? adaptorJSON : ""}' class="product-form__submit button01">
        <span>加入購物車</span>
        <div class="loading-overlay__spinner hidden">
          <svg
            aria-hidden="true"
            focusable="false"
            role="presentation"
            class="spinner"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </ajax-AddToCartButton>`;
        // Create a new DOMParser instance
        const parser = new DOMParser();
        const doc = parser.parseFromString(buttonHtml, 'text/html');
        const buttonElement = doc.body.firstChild;
        return buttonElement;
    }
    getNoAddWiperInfo(message) {
        const contentWrapper = document.createElement('div');
        const messageP = document.createElement('p');
        messageP.innerText = message;
        this.bulkInsertElm(contentWrapper, [messageP]);
        return contentWrapper;
    }
    // DOM changes
    bulkInsertElm(target, subject) {
        const inserted = target;
        subject.forEach((el) => {
            inserted.insertAdjacentElement('beforeend', el);
        });
        return inserted;
    }
    hideBrandDiv(countItem, handler) {
        const brandDiv = document.createElement('div');
        const title = document.createElement('span');
        const counts = document.createElement('span');
        title.innerText = countItem.value;
        counts.innerText = `(${countItem.count})`;
        const insertedbrandDiv = this.bulkInsertElm(brandDiv, [title, counts]);
        insertedbrandDiv.addEventListener('click', () => {
            const bound = handler.bind(this);
            bound(title);
        });
        return insertedbrandDiv;
    }
    clearModelsResult() {
        const resultDiv = document.getElementById(this.initState.sectionsId.resultsArea);
        if (!resultDiv)
            return;
        resultDiv.innerHTML = '';
    }
    printModelsResult(res) {
        const resultDiv = document.getElementById(this.initState.sectionsId.resultsArea);
        if (!resultDiv)
            return;
        const documents = this.getModelDocuments(res);
        const divs = documents.map((el) => {
            const div = this.getModelDiv(el, () => { this.modelDivHandler(el); });
            return div;
        });
        divs.forEach((el_01) => {
            resultDiv.insertAdjacentElement('beforeend', el_01);
        });
        if (res.found === 0)
            this.printNoSearchResult(resultDiv);
    }
    showBrandItem(item, count) {
        const countSpan = item.querySelector('.brand_count');
        countSpan.innerText = JSON.stringify(count);
        item.style.display = 'block';
    }
    hideBrandItem(item) {
        item.style.display = 'none';
    }
    printCurrentQueries() {
        const viewPort = document.getElementById(this.initState.sectionsId.queriesVP);
        if (!viewPort)
            return;
        const modelQueryDiv = this.getCurrentQueriesDiv();
        const brandQueryDiv = this.getCurrentBrandDiv();
        viewPort.innerHTML = "";
        this.bulkInsertElm(viewPort, [brandQueryDiv]);
    }
    printBrandsResult(res) {
        const brandContainer = document.getElementById(this.initState.sectionsId.brandSelect);
        if (!brandContainer)
            return;
        const brandItems = Array.from(brandContainer.querySelectorAll('.wiperBrandSelector_item'));
        const searchedBrands = this.getSearchedBrands(res);
        brandItems.forEach((item) => {
            let searched = false;
            const itemTitle = item.dataset.brandtitle;
            if (!itemTitle)
                return;
            searchedBrands.forEach((el_01) => {
                if (el_01.value === itemTitle) {
                    searched = true;
                    this.showBrandItem(item, el_01.count);
                }
            });
            if (searched === false) {
                this.hideBrandItem(item);
            }
        });
    }
    printNoSearchResult(resultDiv) {
        resultDiv.innerHTML = '';
        const noResultsDiv = document.createElement('div');
        const noResultText = document.createElement('p');
        noResultsDiv.classList.add('wiperSearchReseult_noResult');
        noResultText.innerText = "找不到此車款。請再輸入或聯絡客服協助。";
        this.bulkInsertElm(noResultsDiv, [noResultText]);
        this.bulkInsertElm(resultDiv, [noResultsDiv]);
    }
    hideManyPagination(target) {
        const hiddenNodes = Array.from(target.children).map((el, ind, arr) => {
            const elm = el;
            const pageNum = Number(elm.innerText);
            const currentPage = this.currentState.query.page;
            elm.style.display = 'none';
            if (pageNum === currentPage) {
                elm.style.display = 'block';
                elm.classList.add('currentPage');
            }
            if (pageNum >= currentPage - 2 && pageNum <= currentPage) {
                elm.style.display = 'block';
            }
            if (pageNum <= currentPage + 2 && pageNum >= currentPage) {
                elm.style.display = 'block';
            }
            if (ind === 0 || ind === 1 || ind === 2 || ind === arr.length - 1 || ind === arr.length - 2) {
                elm.style.display = 'block';
            }
            if (elm.style.display === 'none') {
                elm.innerText = "...";
            }
            return elm;
        }).map((el_01, ind_01, arr_01) => {
            const prevElm = arr_01[ind_01 - 1];
            const nextElm = arr_01[ind_01 + 1];
            if (el_01.innerText === '...' && nextElm.innerText !== '...') {
                el_01.style.display = 'block';
            }
        });
        return hiddenNodes;
    }
    printResultCount(res) {
        const resultCountTarget = document.getElementById(this.initState.sectionsId.resultCount);
        if (!resultCountTarget)
            return;
        resultCountTarget.innerText = `(${res.found.toString()})`;
    }
    // call TypeSense
    getSearchParams(options) {
        const filterString = options.brand ? `brand:${options.brand}&&remark:!=Disable` : 'remark:!=Disable';
        const params = {
            q: options.model,
            query_by: 'model',
            sort_by: '_text_match:desc',
            facet_by: 'brand',
            max_facet_values: 50,
            filter_by: filterString,
            per_page: this.initState.query.per_page,
            page: options.pageNo
        };
        return params;
    }
    searchWiperDataBase(options) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const searchOption = this.getSearchParams(options);
                const res = yield this.searchWiperCollection(searchOption);
                return res;
            }
            catch (error) {
                console.log(error);
                return false;
            }
        });
    }
    getWiperInfo(wiperHandle) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield moobiQueries.getProductDataByHandle(wiperHandle);
                if (!res || !(res === null || res === void 0 ? void 0 : res.product))
                    throw new Error("No data returned for the wiper from TS product database.");
                const variants = res.product.variants;
                const image = res.product.image.src;
                const href = '/products/' + wiperHandle;
                const title = res.product.title;
                const handle = wiperHandle;
                return { handle, title, variants, image, href };
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    // Evoke states
    evokeModelBrandQueryUpdate() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.searchWiperDataBase({ model: this.currentState.model.modelQuery, brand: this.currentState.brand.brand, pageNo: 1 });
                // console.log(res)
                if (!res)
                    throw new Error('No valid response from wipersearch collection.');
                this.clearModelsResult();
                this.printCurrentQueries();
                this.printResultCount(res);
                this.printModelsResult(res);
                this.printBrandsResult(res);
                this.getPagination(res);
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    evokeBrandUpdate() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.searchWiperDataBase({ model: this.currentState.model.modelQuery, brand: this.currentState.brand.brand, pageNo: 1 });
                if (!res)
                    throw new Error('No valid response from wipersearch collection.');
                this.clearModelsResult();
                this.printModelsResult(res);
                this.getPagination(res);
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    evokePageUpdate() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.searchWiperDataBase({ model: this.currentState.model.modelQuery, brand: this.currentState.brand.brand, pageNo: this.currentState.query.page });
                if (!res)
                    throw new Error('No valid response from wipersearch collection.');
                this.clearModelsResult();
                this.printModelsResult(res);
                this.getPagination(res);
            }
            catch (error) {
                console.log(error);
            }
        });
    }
}
const wiperHepaController = new WiperHepaSearchController({
    brandSelect: 'wiperBrandSelector',
    queryTextField: 'wiperModelQueryInput',
    resultsArea: 'wiperSearchResultsArea',
    queriesVP: 'wiperSearchCurrentQueries_vp',
    resultCount: 'wiperResearchResult_count'
});
